import "./styles.css";
import "./styles.scss";
import "bootstrap/dist/css/bootstrap.min.css";

import React, { useContext, useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { FaBars } from "react-icons/fa";

import { Footer, Sidebar } from "./components";
import { Fallback } from "./components/Fallback";
import { AuthContext } from "./contexts/AuthContext";
import { useStateContext } from "./contexts/ContextProvider";
import Login from "./pages/Login/Login";
import TampilSurveyor from "./pages/Master/Surveyor/TampilSurveyor";
import TampilKolektor from "./pages/Master/Kolektor/TampilKolektor";
import ProfilUser from "./pages/Utility/ProfilUser/ProfilUser";
import UbahProfilUser from "./pages/Utility/ProfilUser/UbahProfilUser";
import DaftarUser from "./pages/Utility/DaftarUser/DaftarUser";
import TambahUser from "./pages/Utility/DaftarUser/TambahUser";
import UbahUser from "./pages/Utility/DaftarUser/UbahUser";
import TampilSetting from "./pages/Utility/Setting/TampilSetting";
import UbahSetting from "./pages/Utility/Setting/UbahSetting";
import TampilDaftarPermohonan from "./pages/Survey/DaftarPermohonan/TampilDaftarPermohonan";
import UbahDaftarPermohonan from "./pages/Survey/DaftarPermohonan/UbahDaftarPermohonan";
import TampilEntryPermohonan from "./pages/Survey/EntryPermohonan/TampilEntryPermohonan";
import TambahEntryPermohonan from "./pages/Survey/EntryPermohonan/TambahEntryPermohonan";
import UbahEntryPermohonan from "./pages/Survey/EntryPermohonan/UbahEntryPermohonan";
import TampilDataPermohonan from "./pages/Survey/DataPermohonan/TampilDataPermohonan";
import TambahDataPermohonan from "./pages/Survey/DataPermohonan/TambahDataPermohonan";
import UbahDataPermohonan from "./pages/Survey/DataPermohonan/UbahDataPermohonan";
import TampilDataVerifikasi from "./pages/Survey/DataVerifikasi/TampilDataVerifikasi";
import TambahDataVerifikasi from "./pages/Survey/DataVerifikasi/TambahDataVerifikasi";
import UbahDataVerifikasi from "./pages/Survey/DataVerifikasi/UbahDataVerifikasi";
import TampilValidasiDataVerifikator from "./pages/Survey/ValidasiDataVerifikator/TampilValidasiDataVerifikator";
import TambahValidasiDataVerifikator from "./pages/Survey/ValidasiDataVerifikator/TambahValidasiDataVerifikator";
import UbahValidasiDataVerifikator from "./pages/Survey/ValidasiDataVerifikator/UbahValidasiDataVerifikator";
import TampilDaftarKunjungan from "./pages/Survey/DaftarKunjungan/TampilDaftarKunjungan";
import TambahDaftarKunjungan from "./pages/Survey/DaftarKunjungan/TambahDaftarKunjungan";
import UbahDaftarKunjungan from "./pages/Survey/DaftarKunjungan/UbahDaftarKunjungan";
import { canUserAccessMenu } from "./constants/userMenuAccess";

const App = () => {
  const { setScreenSize } = useStateContext();
  const { user } = useContext(AuthContext);
  const [collapsed, setCollapsed] = useState(false);
  const [toggled, setToggled] = useState(false);

  const ProtectedRoute = ({ menuAccess, children }) => {
    if (!user) {
      return <Navigate to="/" />;
    }

    if (canUserAccessMenu(user, menuAccess)) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);

      if (window.innerWidth <= 860) {
        setCollapsed(false);
      } else {
        setToggled(false);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [setScreenSize]);

  if (!user) {
    return (
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    );
  }

  return (
    <div className="app-shell">
      <Sidebar
        collapsed={collapsed}
        toggled={toggled}
        handleToggleSidebar={setToggled}
        handleCollapsedChange={() => setCollapsed(!collapsed)}
      />
      <main className="app-main">
        <button
          className="mobile-menu-btn"
          type="button"
          onClick={() => setToggled(true)}
          aria-label="Buka menu"
        >
          <FaBars />
        </button>
        <section className="content-shell">
          <ErrorBoundary FallbackComponent={Fallback}>
            <Routes>
              <Route path="/" element={<Navigate to="/profilUser" />} />
              <Route
                path="/surveyor"
                element={
                  <ProtectedRoute menuAccess="surveyor">
                    <TampilSurveyor />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/surveyor/:id"
                element={
                  <ProtectedRoute menuAccess="surveyor">
                    <TampilSurveyor />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/kolektor"
                element={
                  <ProtectedRoute menuAccess="kolektor">
                    <TampilKolektor />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/kolektor/:id"
                element={
                  <ProtectedRoute menuAccess="kolektor">
                    <TampilKolektor />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/profilUser"
                element={
                  <ProtectedRoute menuAccess="profilUser">
                    <ProfilUser />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/profilUser/:id/edit"
                element={
                  <ProtectedRoute menuAccess="profilUser">
                    <UbahProfilUser />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/daftarUser"
                element={
                  <ProtectedRoute menuAccess="daftarUser">
                    <DaftarUser />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/daftarUser/:id"
                element={
                  <ProtectedRoute menuAccess="daftarUser">
                    <DaftarUser />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/daftarUser/tambahUser"
                element={
                  <ProtectedRoute menuAccess="daftarUser">
                    <TambahUser />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/daftarUser/:id/edit"
                element={
                  <ProtectedRoute menuAccess="daftarUser">
                    <UbahUser />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/namaPemohon"
                element={
                  <ProtectedRoute menuAccess="namaPemohon">
                    <TampilDaftarPermohonan />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/namaPemohon/:id"
                element={
                  <ProtectedRoute menuAccess="namaPemohon">
                    <TampilDaftarPermohonan />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/namaPemohon/:id/edit"
                element={
                  <ProtectedRoute menuAccess="namaPemohon">
                    <UbahDaftarPermohonan />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/permohonan"
                element={
                  <ProtectedRoute menuAccess="permohonan">
                    <TampilEntryPermohonan />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/permohonan/:id"
                element={
                  <ProtectedRoute menuAccess="permohonan">
                    <TampilEntryPermohonan />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/permohonan/tambahPermohonan"
                element={
                  <ProtectedRoute menuAccess="permohonan">
                    <TambahEntryPermohonan />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/permohonan/:id/edit"
                element={
                  <ProtectedRoute menuAccess="permohonan">
                    <UbahEntryPermohonan />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dataPermohonan"
                element={
                  <ProtectedRoute menuAccess="admin">
                    <TampilDataPermohonan />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dataPermohonan/:id"
                element={
                  <ProtectedRoute menuAccess="admin">
                    <TampilDataPermohonan />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dataPermohonan/tambahDataPermohonan"
                element={
                  <ProtectedRoute menuAccess="admin">
                    <TambahDataPermohonan />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dataPermohonan/:id/edit"
                element={
                  <ProtectedRoute menuAccess="admin">
                    <UbahDataPermohonan />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dataVerifikasi"
                element={
                  <ProtectedRoute menuAccess="dataVerifikasi">
                    <TampilDataVerifikasi />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dataVerifikasi/:id"
                element={
                  <ProtectedRoute menuAccess="dataVerifikasi">
                    <TampilDataVerifikasi />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dataVerifikasi/tambahDataVerifikasi"
                element={
                  <ProtectedRoute menuAccess="dataVerifikasi">
                    <TambahDataVerifikasi />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dataVerifikasi/:id/edit"
                element={
                  <ProtectedRoute menuAccess="dataVerifikasi">
                    <UbahDataVerifikasi />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/validasiDataVerifikator"
                element={
                  <ProtectedRoute menuAccess="validasiDataVerifikator">
                    <TampilValidasiDataVerifikator />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/validasiDataVerifikator/:id"
                element={
                  <ProtectedRoute menuAccess="validasiDataVerifikator">
                    <TampilValidasiDataVerifikator />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/validasiDataVerifikator/tambahValidasiDataVerifikator"
                element={
                  <ProtectedRoute menuAccess="validasiDataVerifikator">
                    <TambahValidasiDataVerifikator />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/validasiDataVerifikator/:id/edit"
                element={
                  <ProtectedRoute menuAccess="validasiDataVerifikator">
                    <UbahValidasiDataVerifikator />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/daftarKunjungan"
                element={
                  <ProtectedRoute menuAccess="daftarKunjungan">
                    <TampilDaftarKunjungan />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/daftarKunjungan/:id"
                element={
                  <ProtectedRoute menuAccess="daftarKunjungan">
                    <TampilDaftarKunjungan />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/daftarKunjungan/tambahDaftarKunjungan"
                element={
                  <ProtectedRoute menuAccess="daftarKunjungan">
                    <TambahDaftarKunjungan />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/daftarKunjungan/:id/edit"
                element={
                  <ProtectedRoute menuAccess="daftarKunjungan">
                    <UbahDaftarKunjungan />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/setting"
                element={
                  <ProtectedRoute menuAccess="setting">
                    <TampilSetting />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/setting/:id/edit"
                element={
                  <ProtectedRoute menuAccess="setting">
                    <UbahSetting />
                  </ProtectedRoute>
                }
              />
              <Route path="/unauthorized" element={<p>Unauthorized</p>} />
              <Route path="*" element={<p>Halaman tidak ditemukan!</p>} />
            </Routes>
          </ErrorBoundary>
        </section>
        <Footer />
      </main>
    </div>
  );
};

export default App;
